import React, { useState, useEffect } from 'react';
import './Hero.css';
import { compassIcon, planetIcon, arrowIcon, mouseIcon } from '../assets';

const words = [
  '[JavaScript]',
  '[TypeScript]',
  '[Python]',
  '[React]',
  '[Node.js]',
  '[CSS]',
  '[Terraform]',
  '[Docker]',
  '[Kubernetes]',
  '[C/C++]',
  '[Java]',
  '[Kotlin]',
  '[AWS]',
  '[ML/AI]',
  '[Android Dev]',
];

const Hero = () => {
  const [currentWordIndex, setCurrentWordIndex] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentWordIndex((prevIndex) => (prevIndex + 1) % words.length);
    }, 2000); // Change word every 2 seconds

    return () => clearInterval(intervalId);
  }, []);

  return (
    <div>
      <header>
        <h3>
          <span className="create">□ CREATIVE PORTFOLIO V.0.1</span>
          <span className="calm">
            <img src={compassIcon} alt="Icon" className="hIcon" />
            &nbsp;CALM AND LUNAR
          </span>
          <span className="planet">
            <img src={planetIcon} alt="Icon" className="pIcon" />
            &nbsp;PLANET EARTH / {new Date().getFullYear()}
          </span>
          <span className="rights">ALL RIGHTS RESERVED □</span>
        </h3>
      </header>
      <h4>
        {'////////////////'}
        <span>\\\\\\\\\\\\\\\\\\</span>
      </h4>
      <div className="planet2">
        <span>
          <img src={planetIcon} alt="Icon" className="p2Icon" />
          &nbsp;&nbsp;PLANET EARTH / {new Date().getFullYear()}
        </span>
      </div>

      <div className="title-container">
        <h1>PRATHU</h1>
        <h2>
          SOFTWARE
          <span>{words[currentWordIndex]}</span>
        </h2>
        <h2b>DEVELOPER</h2b>
        <h2c>{words[currentWordIndex]}</h2c>
      </div>

      <div className="scroll-down">
        <img src={mouseIcon} alt="Icon" className="sIcon" />
        <button onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}>
          <img src={arrowIcon} alt="Icon" className="hIcon" />
          &nbsp; Work with me today
        </button>
      </div>
    </div>
  );
};

export default Hero;
